import actions from '../../actionTypes';

export default geoJson => {
  return {
    type: actions.SET_LOCATIONS_GEO_JSON,
    geoJson
  };
};



// WEBPACK FOOTER //
// ./src/reducers/locations/actions/setLocationsGeoJson.js